import { CustomSettingResponseDTO } from '@/core/api/dtos/response/misc/customSetting'
import { CustomSetting } from '@/core/api/entities/misc/customSetting'

import { ImageSettingMapper } from './imageSettingMapper'

export class CustomSettingMapper {
	static toEntity(dto: CustomSettingResponseDTO): CustomSetting {
		return new CustomSetting({
			name: dto.name,
			images: dto.images ? ImageSettingMapper.toEntity(dto.images) : undefined,
		})
	}

	static toEntities(dtos: CustomSettingResponseDTO[]): CustomSetting[] {
		return dtos.map((dto) => this.toEntity(dto))
	}
}
